export const moneyFormatter = new Intl.NumberFormat('th-TH', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const formatFloatNumber = (number: Number, decimal = 0) => {
  return Number(number.toFixed(decimal));
};